module.exports = __webpack_public_path__ + "img/ky1_mb.47113ab2.jpg";